import { atom } from 'jotai';
import { OrderCurrencyExchangeBalance } from '../../resources/account.resource';
import { Loadable, LoadableState } from '../../utils/useLoadableState';

export const balanceForCurrencyAtom = atom<LoadableState<OrderCurrencyExchangeBalance['investableAmount']>>(
  Loadable.uninitialized,
);
